// Library Methods
import axios from "axios";

const EMR_ERROR_MESSAGES: Record<string, string> = {
  hub_home_clinic_only: "Only the hub's home clinic can do this.",
  clinic_not_accessible:
    "You don't have access to one of the selected clinics.",
  clinic_ids_required: "A hub needs at least one clinic.",
  clinic_not_found: "One of the selected clinics doesn't exist.",
  home_clinic_permanent: "The home clinic can't be removed from the hub.",
  clinic_has_connections:
    "Remove the clinic's connections before taking it off the hub.",
  clinic_not_associated: "This hub isn't shared with the selected clinic.",
  hub_alias_invalid: "The alias must be between 1 and 128 characters.",
  connection_source_claimed:
    "Another enabled connection already reads from this source.",
  connection_destination_claimed:
    "This clinic already sends reports to the same host, port and AE title.",
  connection_in_use:
    "Another connection retrieves into this listener, it can't be deleted.",
  connection_kind_immutable: "A connection's source kind can't be changed.",
  export_not_failed: "Only failed reports can be retried.",
  installer_unavailable:
    "The installer isn't available yet. Please try again later.",
  worklist_required:
    "Exams are brought in only for patients on a worklist. Switch on a worklist on this hub first.",
  pac_server_jobs_invalid:
    "A PAC server can have one worklist, one exams and one reports job.",
  pac_server_not_found: "This PAC server no longer exists. Refresh the page.",
  device_unknown: "This device isn't in the device list anymore.",
  transport_not_supported_by_device: "This device can't be connected that way.",
  exam_type_not_supported_by_device:
    "This device doesn't make one of the selected exam types.",
};

const DETAIL_FIRST_CODES = new Set(["connection_configuration_invalid"]);

export const getEMRErrorMessage = (
  error: unknown,
  fallback: string,
  t: (key: string) => string
): string => {
  if (!axios.isAxiosError(error)) return fallback;

  const code: unknown = error.response?.data?.code;
  const detail: unknown = error.response?.data?.detail;

  if (typeof code !== "string") return fallback;

  if (DETAIL_FIRST_CODES.has(code) && typeof detail === "string" && detail) {
    return detail;
  }

  const message = EMR_ERROR_MESSAGES[code];
  return message ? t(message) : fallback;
};
